import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errors: {},
  submitting: false,
};

const Slice = createSlice({
  name: '@admin/Profile|Security',
  initialState,
  reducers: {
    
      savePassword: (state) => {
        state.errors = {};
        state.submitting = true;
      },
      savePasswordSuccess: (state) => {
        state.submitting = false;
      },
      savePasswordFailed: (state, action) => {
        state.errors = action.errors;
        state.submitting = false;
      },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminProfileSecurityReducers: Slice.reducer
}
export default Reducers;